import { SkeletonWithoutBreadcrumbs } from '@townsquare/griffin-main-header';
import Loadable from '@townsquare/loadable';
import { goalUpdateViewRoute } from '@townsquare/routes/goal-updates-view';
import { projectUpdateViewRoute } from '@townsquare/routes/project-updates-view';
import { recentsViewRoute } from '@townsquare/routes/recents-view';
import { savedViewsUpdatesRoute } from '@townsquare/routes/saved-views-updates-view';
import { tagFeedViewRoute } from '@townsquare/routes/tag-feed-view';
import { teamUpdatesViewRoute } from '@townsquare/routes/team-updates-view';

import { goalUpdatesAsideResource } from './resources/goalUpdatesAsideResource';
import { goalUpdatesResource } from './resources/goalUpdatesResource';
import { projectUpdatesAsideResource } from './resources/projectUpdatesAsideResource';
import { projectUpdatesResource } from './resources/projectUpdatesResource';
import { savedViewUpdatesAsideResource } from './resources/savedViewUpdatesAsideResource';
import { savedViewUpdatesResource } from './resources/savedViewUpdatesResource';
import { statusUpdatesNavigationResource } from './resources/statusUpdatesNavigationResource';
import { stayInLoopResource } from './resources/stayInLoopResource';
import { tagUpdatesAsideResource } from './resources/tagUpdatesAsideResource';
import { tagUpdatesResource } from './resources/tagUpdatesResource';
import { teamUpdatesAsideResource } from './resources/teamUpdatesAsideResource';
import { teamUpdatesResource } from './resources/teamUpdatesResource';

const headerLoadableComponent = Loadable({
  loader: () => import(/* webpackChunkName: "statusUpdatesHeader-view" */ './StatusUpdatesHeader/StatusUpdatesHeader'),
  loading: SkeletonWithoutBreadcrumbs,
});

// Goal Updates View
const GoalUpdatesViewLoadable = Loadable({
  loader: () => import(/* webpackChunkName: "goalUpdate-view" */ './GoalUpdatesView/index'),
  loading: () => null,
});
const GoalUpdatesAsideViewLoadable = Loadable({
  loader: () => import(/* webpackChunkName: "goalUpdateAside-view" */ './GoalUpdatesView/GoalUpdatesAsideView'),
  loading: () => null,
});

goalUpdateViewRoute.component = GoalUpdatesViewLoadable;
goalUpdateViewRoute.aside = GoalUpdatesAsideViewLoadable;
goalUpdateViewRoute.header = headerLoadableComponent;
goalUpdateViewRoute.resources = [
  goalUpdatesResource,
  goalUpdatesAsideResource,
  stayInLoopResource,
  statusUpdatesNavigationResource,
];
export const goalUpdateViewRouterRoute = goalUpdateViewRoute;

// Project Updates View
const ProjectUpdatesViewLoadable = Loadable({
  loader: () => import(/* webpackChunkName: "projectUpdate-view" */ './ProjectUpdatesView/index'),
  loading: () => null,
});
const ProjectUpdatesAsideViewLoadable = Loadable({
  loader: () =>
    import(/* webpackChunkName: "projectUpdateAside-view" */ './ProjectUpdatesView/ProjectUpdatesAsideView'),
  loading: () => null,
});

projectUpdateViewRoute.component = ProjectUpdatesViewLoadable;
projectUpdateViewRoute.aside = ProjectUpdatesAsideViewLoadable;
projectUpdateViewRoute.header = headerLoadableComponent;
projectUpdateViewRoute.resources = [
  projectUpdatesResource,
  projectUpdatesAsideResource,
  stayInLoopResource,
  statusUpdatesNavigationResource,
];
export const projectUpdateViewRouterRoute = projectUpdateViewRoute;

// Saved Views Updates
const SavedViewsUpdatesLoadable = Loadable({
  loader: () => import(/* webpackChunkName: "savedViewsUpdates-view" */ './SavedViewUpdates/index'),
  loading: () => null,
});

const SavedViewsUpdatesAsideLoadable = Loadable({
  loader: () =>
    import(/* webpackChunkName: "savedViewsUpdates-aside-view" */ './SavedViewUpdates/SavedViewUpdatesAside'),
  loading: () => null,
});

savedViewsUpdatesRoute.component = SavedViewsUpdatesLoadable;
savedViewsUpdatesRoute.aside = SavedViewsUpdatesAsideLoadable;
savedViewsUpdatesRoute.header = headerLoadableComponent;
savedViewsUpdatesRoute.resources = [
  savedViewUpdatesResource,
  savedViewUpdatesAsideResource,
  statusUpdatesNavigationResource,
];
export const savedViewsUpdatesRouterRoute = savedViewsUpdatesRoute;

// Tag Feed View
const TagFeedViewLoadable = Loadable({
  loader: () => import(/* webpackChunkName: "TagUpdatesView" */ './TagUpdatesView'),
  loading: () => null,
});
const TagFeedAsideViewLoadable = Loadable({
  loader: () => import(/* webpackChunkName: "TagUpdatesAsideView" */ './TagUpdatesView/TagUpdatesAsideView'),
  loading: () => null,
});

tagFeedViewRoute.component = TagFeedViewLoadable;
tagFeedViewRoute.aside = TagFeedAsideViewLoadable;
tagFeedViewRoute.header = headerLoadableComponent;
tagFeedViewRoute.resources = [tagUpdatesResource, tagUpdatesAsideResource, statusUpdatesNavigationResource];
export const tagFeedViewRouterRoute = tagFeedViewRoute;

// Recents View
const RecentsViewLoadable = Loadable({
  loader: () => import(/* webpackChunkName: "RecentsView" */ './RecentsView'),
  loading: () => null,
});

recentsViewRoute.component = RecentsViewLoadable;
export const recentsViewRouterRoute = recentsViewRoute;

// Team Updates View
const TeamUpdatesViewLoadable = Loadable({
  loader: () => import(/* webpackChunkName: "teamUpdates-view" */ './TeamUpdatesView/index'),
  loading: () => null,
});
const TeamUpdatesAsideViewLoadable = Loadable({
  loader: () => import(/* webpackChunkName: "teamUpdates-aside-view" */ './TeamUpdatesView/TeamUpdatesAsideView'),
  loading: () => null,
});

teamUpdatesViewRoute.component = TeamUpdatesViewLoadable;
teamUpdatesViewRoute.aside = TeamUpdatesAsideViewLoadable;
teamUpdatesViewRoute.header = headerLoadableComponent;
teamUpdatesViewRoute.resources = [teamUpdatesResource, teamUpdatesAsideResource, statusUpdatesNavigationResource];
export const teamUpdatesViewRouterRoute = teamUpdatesViewRoute;
